import React, { useState } from "react";
import css from "../../css/find-agent/search-form.module.css";
import autosuggestionCss from "../../css/find-agent/autosuggestion.module.css";
import AutocompleteLocation from "../autocomplete/location";
import Router from "next/router";
import axiosResiInstance from "../../http/axiosResi";
import MagnifyIcon from "../../static/icons/magnify.svg";
import PropTypes from "prop-types";

const getLocation = async (value) => {
    const locations = await axiosResiInstance.get("/autocomplete", {
        params: {
            q: value,
        },
    });

    return locations.data[0];
};

const SearchForm = (props) => {
    const [location, setLocation] = useState(props.city);
    const [locationText, setLocationText] = useState(null);
    const [name, setName] = useState("");

    const handleLocationChange = (locationText, location) => {
        setLocation(location);
        setLocationText(locationText);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        let loc = location;

        if (!location && locationText) {
            loc = await getLocation(locationText.label);
        }

        if (!loc) {
            return false;
        }

        let query = {};

        if (name) {
            query.name = name;
        }

        Router.push(
            {
                pathname: `/agents`,
                query: {
                    ...query,
                    location: loc.url,
                },
            },
            {
                pathname: `/real_estate_agents/${loc.url}`,
                query,
            }
        );
    };

    let defaultLocation = null;

    if (location) {
        defaultLocation = location.label;
    }

    return (
        <form className={css.form} onSubmit={handleSubmit}>
            <div className={css.formGroup}>
                <label htmlFor="area_speciality">Area Speciality</label>
                <AutocompleteLocation
                    placeholder="Enter City, State or Zip Code"
                    onChange={handleLocationChange}
                    theme={autosuggestionCss}
                    value={defaultLocation}
                    id="area_speciality"
                />
            </div>

            <div className={css.formGroup}>
                <label htmlFor="agent_name">Name</label>
                <input
                    type="search"
                    inputMode="search"
                    autoComplete="name"
                    value={name}
                    onChange={(event) => setName(event.target.value)}
                    placeholder="Enter the Agents name"
                    className={css.input}
                    id="agent_name"
                />
            </div>

            <div className={css.formGroup}>
                <button type="submit" className={css.submit}>
                    <MagnifyIcon /> <span>Search</span>
                </button>
            </div>
        </form>
    );
};

SearchForm.propTypes = {
    city: PropTypes.object,
};

export default SearchForm;
